import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import NodataComponent from "../Common/NodataComponent";
import TableWrap from "../Common/Table/Table";
import moment from "moment";

const TripTypeTable = (props) => {
  const tripsData = useSelector(
    (state) => state?.trips?.tripsShow?.data?.response?.trips?.[0] || {}
  );
  const [flightData, setFlightData] = useState([]);
  const {
    flight_reservations = {},
    car_rentals = [],
    hotel_reservations = [],
    other_bookings = [],
  } = tripsData;

  const columns = [
    {
      title: "Ex ID",
      dataIndex: "ex_id",
      key: "ex_id",
    },
    {
      title: "Date - Time",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Merchant",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Category",
      dataIndex: "from_date",
      key: "from_date",
    },
    {
      title: "Payment Mode",
      dataIndex: "to_date",
      key: "to_date",
    },
    {
      title: "Bill",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Amount",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Actions",
      dataIndex: "status",
      key: "status",
    },
  ];

  const flightColumns = [
    {
      title: "Departure Date",
      dataIndex: "departure_date",
      key: "departure_date",
      render: (text) =>text ? moment(text).format("DD-MM-YYYY, HH:mm:ss") : "-",},
    {
      title: "From",
      dataIndex: "from_city",
      key: "from_city",
    },
    {
      title: "To",
      dataIndex: "to_city",
      key: "to_city",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Meal Preference",
      dataIndex: "meal_preference",
      key: "meal_preference",
    },
    {
      title: "Seat Preference",
      dataIndex: "seat_preference",
      key: "seat_preference",
    },
  ];

  const hotelColumns = [
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "From",
      dataIndex: "duration_from",
      key: "duration_from",
    },
    {
      title: "To",
      dataIndex: "duration_to",
      key: "duration_to",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  const carColumns = [
    {
      title: "Departure Date",
      dataIndex: "duration_from",
      key: "duration_from",
      render: (text) =>text ? moment(text).format("DD-MM-YYYY, HH:mm:ss") : "-",
    },
    {
      title: "Arrival Date",
      dataIndex: "duration_to",
      key: "duration_to",
      render: (text) =>text ? moment(text).format("DD-MM-YYYY, HH:mm:ss") : "-",
    },
    {
      title: "Pick Up",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  const othersColumns = [
    {
      title: "Departure Date",
      dataIndex: "departure_date",
      key: "departure_date",
      render: (text) =>text ? moment(text).format("DD-MM-YYYY, HH:mm:ss") : "-",
    },
    {
      title: "Travel mode",
      dataIndex: "travel_mode",
      key: "travel_mode",
    },
    {
      title: "From",
      dataIndex: "from_city",
      key: "from_city",
    },
    {
      title: "To",
      dataIndex: "to_city",
      key: "to_city",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  useEffect(() => {
    if (flight_reservations?.trips) {
      let arr = [];
      let obj = { ...flight_reservations };
      delete obj.trips;
      flight_reservations?.trips?.forEach((ele) => {
        arr.push({
          ...ele,
          ...obj,
        });
      });
      setFlightData(arr);
    }
  }, [flight_reservations]);

  const getColumns = (types) => {
    switch (types) {
      case "trip":
        return columns;
      case "flight":
        return flightColumns;
      case "hotel":
        return hotelColumns;
      case "car":
        return carColumns;
      case "others":
        return othersColumns;
      default:
      // code block
    }
  };

  const getData = (types) => {
    switch (types) {
      case "trip":
        return [];
      case "flight":
        return flightData;
      case "hotel":
        return hotel_reservations;
      case "car":
        return car_rentals;
      case "others":
        return other_bookings;
      default:
        return [];
    }
  };

  return (
    <div className="expenses-table">
      <TableWrap
        columns={getColumns(props?.type)}
        data={getData(props?.type)}
        pagination={false}
        renderEmpty={() => <NodataComponent />}
      />
    </div>
  );
};

export default TripTypeTable;
